import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { ButtonV2 } from "src/components/ButtonV2/ButtonV2.tsx";
import { TextV2 } from "src/components/TextV2/TextV2.tsx";
import { ModalV3 } from "src/components/ModalV3/ModalV3.tsx";
import { loadTranslations } from "src/lib/i18next/loadTranslations.ts";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";
import { useTranslation } from "react-i18next";

await loadTranslations(TranslationNamespaceEnum.UpdateRequiredModal);

export const UpdateRequiredModal = NiceModal.create(() => {
  const modal = useModal();
  const { t } = useTranslation(TranslationNamespaceEnum.UpdateRequiredModal);

  if (!modal.visible) {
    return null;
  }

  const closeModal = () => {
    modal.remove();
    window.dont_ask_about_window_reload = true;
  };

  const reloadPage = () => window.location.reload();

  return (
    <ModalV3 onClose={closeModal}>
      <ModalV3.Positioner>
        <ModalV3.Content>
          <ModalV3.CloseTrigger />
          <ModalV3.Header>
            <ModalV3.Title>{t("title")}</ModalV3.Title>
          </ModalV3.Header>
          <ModalV3.Body
            style={{
              width: 600,
            }}
          >
            <TextV2 variant={"body1"}>{t("description")}</TextV2>
            {/*<div*/}
            {/*  style={{*/}
            {/*    marginTop: "10px",*/}
            {/*  }}*/}
            {/*>*/}
            {/*  <CheckboxV2 label={"Don't ask again for this version"} />*/}
            {/*</div>*/}
          </ModalV3.Body>
          <ModalV3.Footer>
            <ModalV3.FooterButtons>
              <ButtonV2
                style={{
                  flexGrow: 1,
                }}
                onClick={closeModal}
              >
                {t("actions.cancel")}
              </ButtonV2>
              <ButtonV2
                style={{
                  flexGrow: 1,
                }}
                variant={"filled"}
                skin={"info"}
                onClick={reloadPage}
              >
                {t("actions.reload")}
              </ButtonV2>
            </ModalV3.FooterButtons>
          </ModalV3.Footer>
        </ModalV3.Content>
      </ModalV3.Positioner>
    </ModalV3>
  );
});
